import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import styles from '@patternfly/react-styles/css/components/Menu/menu.mjs';
import { css } from '@patternfly/react-styles';
export const MenuBreadcrumb = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (_jsx("div", Object.assign({ className: css(styles.menuBreadcrumb) }, props, { children: children })));
};
MenuBreadcrumb.displayName = 'MenuBreadcrumb';
//# sourceMappingURL=MenuBreadcrumb.js.map